import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'E-mailberichten',
  labels: {
    view_full_message: 'Volledig bericht bekijken',
    status: 'Status:',
    on: 'Aan',
    off: 'Uit',
    next_send: 'Volgende verzending: {{date}}.',
  },
  descriptions: {
    welcome:
      'Eenmalig verzonden wanneer een klant zich abonneert op je marketing-e-mails, behalve bij aanmeldingen via je storefront-formulier. Een klant ontvangt slechts één van Welkom, Welkom ledenclub en Launch-deal.',
    welcome_members_club:
      'Eenmalig verzonden wanneer iemand zich aanmeldt via je storefront-formulier zonder ingestelde aanmeldpromocode, of lid wordt van je VIP-ledenlijst. Een klant ontvangt slechts één van Welkom, Welkom ledenclub en Launch-deal.',
    storefront_promo:
      'Eenmalig verzonden wanneer iemand zich aanmeldt via je storefront-formulier terwijl er een aanmeldpromocode is ingesteld. De e-mail bevat de persoonlijke promocode van de klant.',
    launch_deal:
      'Eenmalig verzonden aan je geïmporteerde klanten, 30 minuten nadat je restaurant live gaat. Klanten die al Welkom of Welkom ledenclub hebben ontvangen, worden overgeslagen.',
    we_miss_you:
      'Verzonden aan abonnees van wie de laatste bestelling meer dan 45 dagen geleden was. Elke ochtend gecontroleerd; een klant ontvangt dit maximaal één keer per 45 dagen.',
    happy_friday:
      'Verzonden aan alle abonnees om 08:00 UTC op de eerste vrijdag van elke even maand (februari, april, juni, augustus, oktober, december).',
    lazy_sunday:
      'Verzonden aan alle abonnees om 08:00 UTC op de eerste zondag van elke oneven maand (januari, maart, mei, juli, september, november).',
    loyalty_program:
      'Wordt verzonden wanneer het cashback-saldo van een klant het minimumbedrag bereikt dat hij kan besteden. Een klant ontvangt dit maximaal één keer per 30 dagen.',
    you_might_also_like:
      'Verzonden 3 dagen na een bestelling met minstens 2 dezelfde items van 6,00 of meer, met een aanbeveling voor een van je populairste items. Een klant ontvangt dit maximaal één keer per 30 dagen.',
  },
  tiles: {
    sends_count: 'Berichten verzonden',
    delivery_rate: 'Afleverpercentage',
    delivered_suffix: 'afgeleverd',
    open_rate: 'Openingspercentage',
    opened_suffix: 'geopend',
    click_rate: 'Klikpercentage',
    clicked_suffix: 'geklikt',
    spam_report_rate: 'Spamklachtpercentage',
    spam_reports_suffix: 'meldingen',
    unsubscribe_rate: 'Uitschrijfpercentage',
    unsubscribes_suffix: 'uitschrijvingen',
  },
  toasts: {
    failed_to_update_status: 'Status bijwerken mislukt',
    failed_to_load_data: 'Gegevens laden mislukt',
  },

  preview_modal: {
    title: 'Sjabloonvoorbeeld',
    labels: {
      subject: 'Onderwerp:',
      close: 'Sluiten',
    },
    toasts: {
      failed_to_load_data: 'Voorbeeldgegevens laden mislukt',
    },
    template_data: {
      recipient_name: '&lt;Voornaam&gt;',
    },
  },
};
